import CSSModules from "react-css-modules";
import styles from "./cardMakeAPayment.scss";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";


@CSSModules(styles, { allowMultiple: true })
export class AmountOptions extends React.Component {
  static propTypes = {
    selected: PropTypes.string,
    onChange: PropTypes.func,
  };

  handleOnClick = (event) => {
    const {value} = event.target;
    this.props.onChange(value);
  }

  render() {
    const options = [
      {value: 'MINIMUM_PAYMENT', text: `Minimum Payment Due`}
    ];
    return (
      <ul styleName="paymentMethods">
        {
          options.map((option) => {
            const selected = option.value === this.props.selected;
            return (
              <li styleName="amountOption" data-at={`amount-option-${option.value}`} key={option.value}>
                <label styleName={classNames(option.className, {selected})}>
                  <input type="radio" name="amountOption" value={option.value} checked={selected} onChange={this.handleOnClick}/>
                  <span styleName="text">{option.text}</span>
                </label>
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default AmountOptions;



// WEBPACK FOOTER //
// ./src/card/AmountOptions.js